import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { State as BgMaxPriceState, Update } from '~/BgMaxPrice/reducer';
import {
	Module,
	ReferenceBasketVersion,
	selectReferenceBasketVersions,
	State as PriceReferencingState,
} from '~/PriceReferencing';
import { Status } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import ParametersPanel from './ParametersPanel';

interface State {
	bgMaxPrice: BgMaxPriceState;
	priceReferencing: PriceReferencingState;
}

interface OwnProps {
	group: UserProductGroup;
}

const selectUpdateStatus = memoizeOne((groupId: string, update: Update | null) => {
	if (update?.groupId !== groupId) {
		return null;
	}

	switch (update.state.name) {
		case 'scheduled':
		case 'fetching':
			return Status.saving;
		case 'updated':
			return Status.saved;
		case 'failed':
			return Status.failed;
		default:
			return null;
	}
});

const mapStateToProps = ({ bgMaxPrice, priceReferencing }: State, { group }: OwnProps) => ({
	updateStatus: selectUpdateStatus(group.id, bgMaxPrice.update),
	versions: selectReferenceBasketVersions(priceReferencing, Module.bgMaxPrice),
});

export default connect(mapStateToProps)(ParametersPanel);
